import { render, staticRenderFns } from "./BannerCreateVersion.vue?vue&type=template&id=2bd23633&lang=pug"
import script from "./BannerCreateVersion.vue?vue&type=script&lang=js"
export * from "./BannerCreateVersion.vue?vue&type=script&lang=js"
import style0 from "./BannerCreateVersion.vue?vue&type=style&index=0&id=2bd23633&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports